import { useSearchParams } from 'react-router-dom';

import {
  eavierAdminAuthApplicationIds,
  eavierMiniAppAuthApplicationIds,
  eavierUserAuthApplicationIds,
  eavierWebAuthApplicationIds,
} from '@/constants/eavier-auth';
import { searchKeys } from '@/shared/utils/search-parameters';

export type EavierAuthAudience = 'admin' | 'user' | 'miniapp';

export const getEavierAuthAudience = (
  applicationId?: string | null
): EavierAuthAudience | undefined => {
  if (applicationId && eavierAdminAuthApplicationIds.has(applicationId)) {
    return 'admin';
  }

  if (applicationId && eavierUserAuthApplicationIds.has(applicationId)) {
    return 'user';
  }

  if (applicationId && eavierMiniAppAuthApplicationIds.has(applicationId)) {
    return 'miniapp';
  }
};

export const isEavierAuthApplication = (applicationId?: string | null) =>
  Boolean(getEavierAuthAudience(applicationId));

const useApplicationId = () => {
  const [searchParameters] = useSearchParams();

  return searchParameters.get(searchKeys.appId) ?? sessionStorage.getItem(searchKeys.appId);
};

export const isEavierWebAuthApplication = (applicationId?: string | null) =>
  Boolean(applicationId && eavierWebAuthApplicationIds.has(applicationId));

export const useEavierAuthAudience = () => getEavierAuthAudience(useApplicationId());

export const useEavierWebAuthBranding = () => isEavierWebAuthApplication(useApplicationId());

const useEavierAuthTheme = () => Boolean(useEavierAuthAudience());

export default useEavierAuthTheme;
